import { useTranslation } from "react-i18next";
import { MeasurePanel } from "./MeasurePanel";

export function MobileMeasureOverlay({
  onClose,
  firstRunByVariant,
  loadingModes = false,
  isPermitted,
}) {
  const { t } = useTranslation();

  return (
    <div className="fixed inset-0 z-40 md:hidden">
      <button
        type="button"
        className="absolute inset-0 bg-greyscale-2/20"
        aria-label={t("close", "Close")}
        onClick={onClose}
      />

      <div className="absolute inset-x-0 bottom-0 border-t border-greyscale-3 bg-container p-4 pb-20 animate-[slideUp_0.25s_ease-out]">
        <MeasurePanel
          onClose={onClose}
          firstRunByVariant={firstRunByVariant}
          loadingModes={loadingModes}
          isPermitted={isPermitted}
        />
      </div>

      <style>{`
        @keyframes slideUp {
          from { transform: translateY(100%); }
          to   { transform: translateY(0); }
        }
      `}</style>
    </div>
  );
}
